import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Sparkles } from 'lucide-react';
import { Button } from './Button';
export function MainContent() {
  const books = [{
    title: 'Enciclopedia Gluko Libre Argentina',
    desc: 'El libro principal con más de 100 recetas paso a paso.',
    color: 'bg-primary',
    delay: 0.1
  }, {
    title: 'Plan Reseteo 7 días',
    desc: 'Menú completo para tu primera semana.',
    color: 'bg-accent',
    delay: 0.2
  }, {
    title: 'Manual de Reemplazos Inteligentes',
    desc: 'Adaptá cualquier receta fácilmente.',
    color: 'bg-gray-800',
    delay: 0.3
  }, {
    title: 'Recetario de Bebidas',
    desc: 'Opciones deliciosas sin azúcar.',
    color: 'bg-[#166534]',
    delay: 0.4
  }];
  return <section className="py-14 md:py-20 px-5 bg-white overflow-hidden" data-id="element-90">
      <div className="max-w-6xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-92">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent/10 text-accent mb-4" data-id="element-93">
            <Sparkles className="w-6 h-6" data-id="element-94" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-black text-gray-900 mb-3" data-id="element-95">
            QUÉ VAS A RECIBIR
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-96">
            Una colección digital premium diseñada para transformar tu
            alimentación desde el primer día.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-97">
          {books.map((book, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: book.delay,
          duration: 0.6
        }} className="relative group perspective-1000" data-id="element-98">
              {/* 3D Book Mockup Effect */}
              <div className={`relative w-full aspect-[3/4] ${book.color} rounded-r-2xl rounded-l-md shadow-xl transform transition-transform duration-500 group-hover:rotate-y-[-10deg] group-hover:scale-105`} data-id="element-99">
                {/* Book Spine */}
                <div className="absolute left-0 top-0 bottom-0 w-4 bg-black/20 rounded-l-md" data-id="element-100" />
                {/* Book Cover Content */}
                <div className="absolute inset-0 pl-6 pr-4 py-5 flex flex-col justify-between" data-id="element-101">
                  <BookOpen className="w-6 h-6 text-white/50" data-id="element-102" />
                  <div data-id="element-103">
                    <h3 className="text-base md:text-xl font-serif font-bold text-white leading-tight mb-1.5" data-id="element-104">
                      {book.title}
                    </h3>
                    <p className="text-xs md:text-sm text-white/80 font-medium leading-snug" data-id="element-105">
                      {book.desc}
                    </p>
                  </div>
                </div>
                {/* Book Pages Edge (Right) */}
                <div className="absolute right-0 top-2 bottom-2 w-2 bg-white/90 rounded-r-sm translate-x-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-106" />
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-10" data-id="element-107">
          <Button data-id="element-108">QUIERO VOLVER A DISFRUTAR LA COMIDA</Button>
        </div>
      </div>
    </section>;
}